import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ForeignKeyValidator } from '../../../../core/_infrastructure/classes/foreignKeyValidator';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { EnumIdsTcPais, Tc } from '../../../../core/_infrastructure/types/common';
import { SolicitudExService } from '../solicitudesex.service';
import { EditSolicitudExPcfViewModel, SolicitudExViewModel } from '../solicitudesex.types';
import { TInterValoHoraPuntoInspeccionViewModel } from '../../puntosinspeccion/puntoinspeccion.types';
import { HttpParams } from '@angular/common/http';
import { PuntoInspeccionService } from '../../puntosinspeccion/puntoinspeccion.service';
import { InspeccionesExService } from '../../../../_exportacion/solicitudes/inspecciones/inspeccionesEx.service';
import { ReasignacionPcfViewModel } from '../../../../_exportacion/solicitudes/inspecciones/inspeccionesEx.types';
import { EnumIdsTcEstadoSolicitudEx } from '../../../../_exportacion/solicitudes/types/enum';
import { SolicitudesexEditComponent } from '../solicitudesex-edit/solicitudesex-edit.component';

@Component({
    selector: 'app-solicitudesex-wrapper-edit',
    templateUrl: './solicitudesex-wrapper-edit.component.html',
    styleUrls: ['./solicitudesex-wrapper-edit.component.scss'],
})
export class SolicitudesexWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    solicitudEx: SolicitudExViewModel;
    formGroup: FormGroup;

    estadoSolicitudEx: Tc[];

    successMessage = 'El estado de la Solicitud ha sido modificado correctamente';
    listUrl = '/mantenimiento/general/solicitudesEx';

    //activateRoute$ = this.activateRoute.paramMap.subscribe(params => {
    //    const id: any = params.get('id');
    //    if (id) {
    //        this.getSolicitudEx(id);
    //        this.getUltimaReasignacionPcf(id);
    //        this.inspeccionesExService.aplicaDocumentacionUk(id).subscribe(res => {
    //            this.aplicaDocumentacionUk = res;
    //        });
    //    }
    //});

    listPuntoInspeccion: Tc[] = [];
    listHoras: TInterValoHoraPuntoInspeccionViewModel[] = [];
    listUbicacion: Tc[] = [];
    listInstalacionAutorizada: Tc[] = [];
    aplicaDocumentacionUk = false;

    IdProvincia: number | null = null;
    esGrabador = false;

    reasignacionPcf: ReasignacionPcfViewModel;

    onAplica$ = new EventEmitter<any>();

    constructor(
        private fb: FormBuilder,
        private activateRoute: ActivatedRoute,
        private router: Router,
        private solicitudesexService: SolicitudExService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private puntoInspeccionService: PuntoInspeccionService,
        private inspeccionesExService: InspeccionesExService,
        protected globalService: GlobalService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.buildForm();
        const params = new HttpParams()
            .set('idpais', EnumIdsTcPais.ID_ESPANA.toString())
            .set('esgrabador', this.esGrabador.toString())
            .set('idusuario', this.loggedInUser!.Id.toString());

        this.globalService.getPuntoInspeccionNuevaSolicitudExportacion(params).subscribe(res => {
            this.listPuntoInspeccion = res;
        });

        this.activateRoute.paramMap.subscribe(params => {
            const id = +params.get('id')!;
            if (id) {
                this.getSolicitudEx(id);
                this.getUltimaReasignacionPcf(id);
                this.inspeccionesExService.aplicaDocumentacionUk(id).subscribe(res => {
                    this.aplicaDocumentacionUk = res;
                    // Emitir el valor actualizado al hijo
                    this.onAplica$.emit(this.aplicaDocumentacionUk);
                });
            }
        });
    }

    obtenerDatosPorPuntoInspeccion(idPuntoInspeccion: number) {
        if (!idPuntoInspeccion) {
            this.listUbicacion = [];
            this.listInstalacionAutorizada = [];
            this.listHoras = [];
            return;
        }

        this.obtenerUbicaciones(idPuntoInspeccion);
        this.obtenerIntervalosHora(idPuntoInspeccion);

        this.puntoInspeccionService.getPuntoInspeccion(idPuntoInspeccion).subscribe(result => {
            this.IdProvincia = result.IdProvincia;
            this.obtenerInstalacionesAutorizadas(this.IdProvincia!);
        });
    }

    obtenerUbicaciones(idPuntoInspeccion: number) {
        const params = new HttpParams().set('id', idPuntoInspeccion.toString()).set('esexportacion', 'true');
        this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
            this.listUbicacion = res;
        });
    }

    obtenerInstalacionesAutorizadas(idProvincia: number) {
        this.globalService.getInstalacionesAutorizadasByProvincia(idProvincia).subscribe(res => {
            this.listInstalacionAutorizada = res;
        });
    }

    obtenerIntervalosHora(idPuntoInspeccion: number) {
        this.inspeccionesExService.getIntervalosHora(idPuntoInspeccion).subscribe(res => {
            this.listHoras = res;
        });
    }

    getUltimaReasignacionPcf(idSolicitudEx: number) {
        this.inspeccionesExService.getUltimaReasignacionPcf(idSolicitudEx).subscribe(res => {
            this.reasignacionPcf = res;
            this.obtenerDatosPorPuntoInspeccion(this.reasignacionPcf.IdPuntoInspeccion);
        });
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            CodigoSolicitudEx: ['', Validators.required],
            NumeroCertificadoEx: '',
            IdEstadoSolicitudEx: ['', Validators.required],
            FechaEnvio: [null],

            IdPuntoInspeccion: [null, Validators.required],
            IdUbicacion: [null, Validators.required],
            IdInstalacionAutorizada: [null, Validators.required],
            IdIntervaloHoras: [null],
            IdTipoSolicitudEx: '',
        });

        this.form = this.formGroup;
        this.getEstadoSolicitudEx();
    }

    private getEstadoSolicitudEx(): void {
        this.globalService.getEstadoSolicitudExpor().subscribe((items: Tc[]) => {
            this.estadoSolicitudEx = items;
        });
    }

    private getSolicitudEx(id: number): void {
        this.solicitudesexService
            .getSolicitudEx(id)
            .pipe(
                tap((v: SolicitudExViewModel) => {
                    this.solicitudEx = v;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    private noEsEstadoDeReasignacionPcf(estadoId: number): boolean {
        const estadosQuePermitenReasignacion = [
            EnumIdsTcEstadoSolicitudEx.ID_FINALIZADA_CONFORME,
            EnumIdsTcEstadoSolicitudEx.ID_RECHAZADA_INSPECTOR,
            EnumIdsTcEstadoSolicitudEx.ID_ANULADA,
            EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA,
            EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE,
        ];
        return estadosQuePermitenReasignacion.includes(estadoId);
    }

    onSave(): void {
        this.visibilitySpinner = true;

        const model = { ...this.formGroup.value };

        const payload = new EditSolicitudExPcfViewModel();

        payload.Id = this.solicitudEx.Id;
        payload.Codigo = model.CodigoSolicitudEx;
        payload.NumeroCertificado = model.NumeroCertificadoEx;
        payload.IdEstadoSolicitudEx = model.IdEstadoSolicitudEx;
        payload.IdTipoSolicitudEx = this.solicitudEx.IdTipoSolicitudEx;
        payload.FechaEnvio = this.solicitudEx.FechaEnvio;

        const noEsEstadoDeReasignacionPcf = this.noEsEstadoDeReasignacionPcf(payload.IdEstadoSolicitudEx);

        if (
            (noEsEstadoDeReasignacionPcf && this.solicitudEx.IdEstadoSolicitudEx != model.IdEstadoSolicitudEx) ||
            (!this.aplicaDocumentacionUk && this.solicitudEx.IdEstadoSolicitudEx != model.IdEstadoSolicitudEx) ||
            (this.solicitudEx.IdEstadoSolicitudEx != model.IdEstadoSolicitudEx && model.IdPuntoInspeccion == this.reasignacionPcf.IdPuntoInspeccion)
        ) {
            payload.IdPuntoInspeccion = this.reasignacionPcf.IdPuntoInspeccion;
            payload.IdUbicacion = this.reasignacionPcf.IdUbicacion;
            payload.IdInstalacionAutorizada = this.reasignacionPcf.IdInstalacionAutorizada;
            payload.IdIntervaloHoras = this.reasignacionPcf.IdIntervaloHoras;
        } else {
            const camposObligatorios = [model.IdEstadoSolicitudEx, model.IdPuntoInspeccion, model.IdUbicacion || model.IdInstalacionAutorizada];

            const camposBasicosIncompletos = camposObligatorios.some(campo => campo === null || campo === undefined);

            const tieneUbicacionOInstalacion = !!model.IdUbicacion || !!model.IdInstalacionAutorizada;

            if (model.IdPuntoInspeccion === this.reasignacionPcf.IdPuntoInspeccion) {
                this.addErrorMessage('No se puede reasignar un mismo punto de inspección');
                this.visibilitySpinner = false;
                return;
            }

            if (camposBasicosIncompletos && !tieneUbicacionOInstalacion) {
                this.addErrorMessage('Debe completar todos los campos requeridos.');
                this.visibilitySpinner = false;
                return;
            }

            payload.IdPuntoInspeccion = model.IdPuntoInspeccion;
            payload.IdUbicacion = model.IdUbicacion;
            payload.IdInstalacionAutorizada = model.IdInstalacionAutorizada;
            payload.IdIntervaloHoras = model.IdIntervaloHoras;
        }

        this.solicitudesexService
            .saveSolicitudExPcf(payload)
            .pipe(
                tap(() => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.form?.valid || !this.form?.dirty || this.form?.pristine;
    }
}
